export default {
  numbersBlacklist: state => state.numbersBlacklist
}
